import React from "react";
import { Translate as T } from "react-redux-i18n";
import Scrollable from "../Scrollable/Scrollable";

import styles from "./Crossword.css";

import CellsContainer from "../Cells/CellsContainer";
import KeyboardContainer from "../Keyboard/KeyboardContainer";
import NavBarContainer from "../NavBar/NavBarContainer";
import Pirate from "../Pirate/Pirate";

const Crossword = ({ prizesShowing }) => (
  <div className={styles.crossword}>
    <h1 className={styles.title}>
      <T value="title" />
      <em>{process.env.PUBLIC_URL}</em>
    </h1>

    <NavBarContainer />

    <Scrollable className={styles.cells}>
      <div className={styles.container}>
        <CellsContainer />
      </div>
    </Scrollable>

    <section className={styles.keyboard}>
      {!prizesShowing && (
        <div className={styles.pirate}>
          <Pirate />
        </div>
      )}

      <KeyboardContainer />
    </section>
  </div>
);

export default Crossword;



// WEBPACK FOOTER //
// ./src/components/Crossword/Crossword.js